import '../../App.css';
import '../../css/bootstrap.scss';
import QR_code from "../../images/QR_code.png";
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import info_circle from "../../images/info-circle.png";
import google_icon from "../../images/google.png";
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import { useState, useRef } from 'react';
import axios from 'axios';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../renderField';
import { connect } from 'react-redux';
import { setEmail, setwizardPageNumber, setFaceID } from '../LoginReducer';
import { RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import { AxiosError } from 'axios';
import FirstForm from './FirstForm';
import SecondForm from './SecondForm';
import { useTranslation } from 'react-i18next';

interface FormData {

}

interface Props { };

const Login: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.loginAccount.wizardPageNumber);
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);
    const [activeNavItem, setActiveNavItem] = useState('Face ID');

    const handleNavItemClick = (item: any) => {
        setActiveNavItem(item);
    };

    return (
        <>
            <Header />
            <ToastBox />
            <Container fluid className='min-vh-custom'>
                <Row>
                    <Col md={1}>
                    </Col>

                    <Col md={5}>
                        <div className='mt-5 '>
                            <br />

                            <h3 className='text-black  mt-5 py-3 mb-3'>{t('login.title')}</h3>
                            <div>
                                <Col md={9} >
                                    <Nav variant="tabs" defaultActiveKey="/home" className='rounded-5 border-0' style={{ background: '#F6F7F9' }}>
                                        <Nav.Item>
                                            <Nav.Link
                                                eventKey="face_id"
                                                className={`rounded-5 py-3 px-3 ${activeNavItem === 'Face ID' ? 'active' : ''}`}
                                                onClick={() => handleNavItemClick('Face ID')}
                                            >
                                                {t('login.face_id')}
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                eventKey="mfa"
                                                className={`rounded-5 py-3 px-3 ${activeNavItem === 'Multi Factor Authentication' ? 'active' : ''}`}
                                                onClick={() => handleNavItemClick('Multi Factor Authentication')}
                                            >
                                                {t('login.mfa')}
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item >
                                            <Nav.Link
                                                eventKey="biometrics"
                                                className={`rounded-5 py-3 px-3  ${activeNavItem === 'Biometrics' ? 'active' : ''}`}
                                                onClick={() => handleNavItemClick('Biometrics')}
                                            >
                                                {t('login.biometrics')}
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                            </div>

                            <Row className={activeNavItem === 'Face ID' ? '' : 'd-none'} id="face_id_div">
                                <FirstForm />
                            </Row>

                            <Row className={activeNavItem === 'Multi Factor Authentication' ? '' : 'd-none'} id="multifactor_auth_div">
                                <SecondForm />
                            </Row>

                            <Row className={activeNavItem === 'Biometrics' ? '' : 'd-none'} id="biometrics_div">
                                <Form noValidate validated={validated} className='mt-5'>
                                    <Row className='px-3'>
                                        <Col md={11} style={{ background: "#F9FAFB" }} className="d-flex align-items-center p-2">
                                            <img src={info_circle} width={28} alt="Info" className="mx-1" />&nbsp;&nbsp;&nbsp;&nbsp;
                                            <p className='text-secondary'>
                                                {t('login.biometrics_note')}
                                            </p>
                                        </Col>
                                    </Row>

                                    <Row className=''>
                                        <Col md={6} className='py-4'>
                                            <Button className='btn btn-primary px-4 py-2  mt-3 rounded-5'>{t('login.login_btn')}</Button>
                                        </Col>
                                    </Row>

                                    <Row className='py-1'>
                                        <div className="col-md-12 d-flex align-items-center justify-content-center">
                                            <hr className="flex-grow-1 mx-4" />
                                            <div className="centered-text text-secondary">{t('login.or_continue')}</div>
                                            <hr className="flex-grow-1 mx-4" />
                                        </div>
                                    </Row>
                                    <Row className='mt-3'>
                                        <Col md={6}>
                                            <Button
                                                className="btn btn-primary  mt-2 rounded-5 bg-white text-black w-100 "
                                                onClick={() => { navigate('/register_entity_account') }}
                                                style={{ border: '1px solid #C5CCD6' }}
                                            >
                                                <img src={google_icon} style={{ width: '20px' }} />
                                                &nbsp;
                                                <span className='small'>{t('login.google')}</span>
                                            </Button>
                                        </Col>
                                        <Col md={6}>
                                            <Button
                                                className="btn btn-primary  mt-2 rounded-5 bg-white text-black w-100 "
                                                onClick={() => { navigate('/register_entity_account') }}
                                                style={{ border: '1px solid #C5CCD6' }}
                                            >
                                                <i className="fa-brands fa-apple" style={{ fontSize: '21px' }} ></i>
                                                &nbsp; &nbsp;
                                                <span className='small'>{t('login.apple')}</span>
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row className='text-center mt-5 mb-5'>
                                        <span>{t('login.no_account_q')} <Link className='text-primary' to={"/"}>{t('login.register_link')}</Link></span>
                                    </Row>
                                </Form>
                            </Row>
                        </div>
                    </Col>
                    <Col md={6} className='text-center'  >
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <Row className=' text-center'>
                            <Col md={3}>
                            </Col>
                            <Col md={6} className=' mb-3' style={{ background: "#F9FAFB" }} >
                                <img className='mt-5' src={QR_code} width={130} />
                                <br />
                                <br />
                                <h4 className='fw-bold'>{t('login.scan_qr_login')}</h4>
                                <p className='text-secondary small'>{t('login.scan_qr_desc')}</p>

                                <Button className='btn btn-dark mb-5 mt-3 rounded-5 py-3 px-5'>{t('login.get_app')}</Button>
                            </Col>
                            <Col md={3}>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container >
            <Footer full={true} />
        </>
    );
}


const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,

})(Login);

export default connect(null)(form);
